import { PnlPivotGrid } from '@approot/positions-detail/pnl-blotter/pnl-pivot-table/pnl-pivot.types';
import { BackToBackGrid } from '@approot/positions-detail/white-label-blotter/back-to-back-trades/back-to-back-trades.types';
import { Tabs } from '@approot/services';
import { ColumnState } from 'ag-grid-community';

export const DciGridDefaultsStateKey = 'dciGridDefaults';
export const ReportingCurrencyStateKey = 'reportingCurrency';
export const RfqSettingsStateKey = 'rfq-settings';
export const UserPreferencesStateKey = 'userPreferences';
export const EventsBlotterGridStateKey = 'eventsBlotterGridState';
export const RiskBlotterGridStateKey = 'risksBlotterGridState';
export const LifecycleBlotterGridStateKey = 'lifecycleBlotterGridState';
export const BlotterGridStateKey = 'blotterGridState';
export const PNLBlotterGridStateKey = 'PNLBlotterGridState';
export const PNLPivotGridsStateKey = 'PNLPivotGridsState';
export const BackToBackGridsStateKey = 'BackToBackGridsState';
export const AutoQuoteStorageStateKey = 'enableProviderAutoQuote';
export const CashFlowsBlotterGridStateKey = 'cashFlowsBlotterGridState';
export const TradeGridStateKey = 'tradeGridState';
export const TradeFilterStateKey = 'tradeFiltertate';
export const UseDefaultsStateKey = 'useDefaults';
export const DefaultsStateKey = 'defaults';
export const RiskBlotterTimeZoneStateKey = 'RisksBlotter:timezone';
export const LifecycleBlotterTimeZoneStateKey = 'LifeCycleBlotter:timezone';
export const PNLBlotterTimeZoneStateKey = 'PNLBlotter:timezone';
export const StrategyDetailTabsStateKey = 'strategyDetailTabs';
export const ExcludedTradeStatusesKey = 'excludedTradeStatuses';

export interface DciTabState {
  tabs?: Record<
    string,
    {
      dates?: Record<
        string,
        {
          expiryDate?: string;
          settlementDate?: string;
        }
      >;
      cutOff?: string;
      strikesYields?: string[];
    }
  >;
  controlPanel?: {
    currency?: string;
    amount?: string;
    marginBps?: string;
    depositTaker?: string;
    interest?: string;
    solveFor?: string;
  };
}

export interface RfqSettingsState {
  'leg-attributes'?: Record<string, any>;
  'rfq-details-settings'?: Record<
    string,
    {
      account: string;
      entity: string;
      primeBroker: string;
      premium: string;
      premiumValue: string;
      premiumDate: string;
      hedge: string;
      hedgeMode: string;
      hedgeRate: string;
      hedgeAmount: string;
      hedgeDirection: string;
      hedgeDirectionBid: string;
      banks: {
        id: number;
        name: string;
        shortName: string;
      }[];
    }
  >;
  'pricing-setting'?: {
    'one-way'?: boolean;
  };
}

export interface UserPreferencesState {
  PricingDisplayPrefs?: Record<string, boolean>;
  OtherSettings?: {
    sounds?: boolean;
    soundLevel?: 'quiet' | 'medium' | 'loud';
  };
}

export type UserStorageFieldName =
  | typeof ReportingCurrencyStateKey
  | typeof RfqSettingsStateKey
  | typeof UserPreferencesStateKey
  | typeof DciGridDefaultsStateKey
  | typeof EventsBlotterGridStateKey
  | typeof RiskBlotterGridStateKey
  | typeof LifecycleBlotterTimeZoneStateKey
  | typeof LifecycleBlotterGridStateKey
  | typeof BlotterGridStateKey
  | typeof PNLBlotterGridStateKey
  | typeof PNLPivotGridsStateKey
  | typeof BackToBackGridsStateKey
  | typeof CashFlowsBlotterGridStateKey
  | typeof AutoQuoteStorageStateKey
  | typeof TradeGridStateKey
  | typeof TradeFilterStateKey
  | typeof UseDefaultsStateKey
  | typeof DefaultsStateKey
  | typeof RiskBlotterTimeZoneStateKey
  | typeof PNLBlotterTimeZoneStateKey
  | typeof StrategyDetailTabsStateKey
  | typeof ExcludedTradeStatusesKey;

export type DefaultsState = Record<string, string>[];
export type ExcludedStradeStatuses = string[];

export interface UserStorageState {
  [DciGridDefaultsStateKey]?: DciTabState;
  [ReportingCurrencyStateKey]?: string;
  [RfqSettingsStateKey]?: RfqSettingsState;
  [UserPreferencesStateKey]?: UserPreferencesState;
  [EventsBlotterGridStateKey]?: ColumnState[];
  [RiskBlotterGridStateKey]?: ColumnState[];
  [LifecycleBlotterGridStateKey]?: ColumnState[];
  [BlotterGridStateKey]?: ColumnState[];
  [PNLBlotterGridStateKey]?: ColumnState[];
  [PNLPivotGridsStateKey]?: PnlPivotGrid[];
  [BackToBackGridsStateKey]?: BackToBackGrid[];
  [AutoQuoteStorageStateKey]?: string;
  [CashFlowsBlotterGridStateKey]?: ColumnState[];
  [TradeGridStateKey]?: ColumnState[];
  [TradeFilterStateKey]?: Record<string, any>;
  [UseDefaultsStateKey]?: boolean;
  [DefaultsStateKey]?: DefaultsState;
  [RiskBlotterTimeZoneStateKey]?: string;
  [StrategyDetailTabsStateKey]?: Tabs;
  [ExcludedTradeStatusesKey]?: ExcludedStradeStatuses;
}
